import React, {

    useEffect,

    useState

}

from "react";

import {

    FontAwesomeIcon

}

from "@fortawesome/react-fontawesome";

import {

    faChevronLeft,

    faChevronRight,

    faExpand

}

from "@fortawesome/free-solid-svg-icons";

import {

    functions

}

from "../../../constants/common-functions";

import {

    OMNISCAN_BLUE

}

from "../../../constants/colors";


import DynamicSnippetSelectionDrawer

from "./DynamicSnippetSelectionDrawer";


//========================================================
// Document Inspection Drawer
//========================================================

export default function DocumentInspectionDrawer({

    visible,

    documentId,

    documentSharepointId,

    documentTitle = "Document",

    pageNumber = 1,

    totalPages: suppliedTotalPages = 1,

    onPreviousPage,

    onNextPage,

    onViewFullDocument,

    onViewSnippets,

    onAddPage

})

{

    //========================================================
    // Dimensions
    //========================================================

    const SNIPPET_DRAWER_WIDTH =
        540;


    const DOCUMENT_DRAWER_WIDTH =
        900;


    //========================================================
    // Page
    //========================================================

    const [currentPage, setCurrentPage] =
        useState(
            pageNumber
        );


    const [documentTotalPages, setDocumentTotalPages] =
        useState(
            suppliedTotalPages
        );


    const [pdfPageUrl, setPdfPageUrl] =
        useState(null);


    const [pdfLoading, setPdfLoading] =
        useState(false);


    const [pdfError, setPdfError] =
        useState(false);


    //========================================================
    // Page Content
    //
    // Structural page content is generated by Forager and
    // persisted in document_snippet_section.
    //
    // The API returns the selectable structural sections for
    // the currently displayed source page.
    //========================================================

    const [pageContentResponse, setPageContentResponse] =
        useState(null);


    const [pageContentLoading, setPageContentLoading] =
        useState(false);


    //========================================================
    // Page Content Selection
    //========================================================

    const [snippetSelectionVisible, setSnippetSelectionVisible] =
        useState(false);


    //========================================================
    // Reset Page
    //
    // When a different search result/document is opened,
    // reset the viewer to the selected result page.
    //========================================================

    useEffect(() =>
    {

        if (
            !visible
        )
        {

            return;

        }


        setCurrentPage(
            pageNumber
        );


        setSnippetSelectionVisible(
            false
        );

    }, [

        visible,

        documentId,

        pageNumber

    ]);


    //========================================================
    // Load Page Metadata
    //========================================================

    useEffect(() =>
    {

        if (
            !visible ||
            !documentId ||
            !currentPage
        )
        {

            return;

        }


        let cancelled =
            false;


        functions.getObjectFromAjax(

            "/resolutionsoftwareplatform/snippet-sniffer/documents/" +
            documentId +
            "/pages/" +
            currentPage,

            function(response)
            {

                if (
                    cancelled
                )
                {

                    return;

                }


                setDocumentTotalPages(

                    response?.totalPages ||
                    suppliedTotalPages ||
                    1

                );

            }

        );


        return () =>
        {

            cancelled =
                true;

        };

    }, [

        visible,

        documentId,

        currentPage,

        suppliedTotalPages

    ]);


    //========================================================
    // Load Page Content
    //
    // Loads the structural sections persisted by Forager.
    //
    // TABULAR / structured pages return no selectable
    // sections and therefore do not display View Content.
    //========================================================

    useEffect(() =>
    {

        if (
            !visible ||
            !documentId ||
            !currentPage
        )
        {

            setPageContentResponse(
                null
            );


            setPageContentLoading(
                false
            );


            return;

        }


        let cancelled =
            false;


        setPageContentResponse(
            null
        );


        setPageContentLoading(
            true
        );


        setSnippetSelectionVisible(
            false
        );


        const url =

            "/resolutionsoftwareplatform/snippet-sniffer/documents/" +
            documentId +
            "/pages/" +
            currentPage +
            "/snippets";


        functions.getObjectFromAjax(

            url,

            function(response)
            {

                if (
                    cancelled
                )
                {

                    return;

                }


                setPageContentResponse(
                    response || null
                );


                setPageContentLoading(
                    false
                );

            }

        );


        return () =>
        {

            cancelled =
                true;

        };

    }, [

        visible,

        documentId,

        currentPage

    ]);


    //========================================================
    // Load PDF Page
    //========================================================

    useEffect(() =>
    {

        if (
            !visible ||
            !documentSharepointId ||
            !currentPage
        )
        {

            setPdfPageUrl(
                null
            );


            return;

        }


        let cancelled =
            false;


        let objectUrl =
            null;


        setPdfLoading(
            true
        );


        setPdfError(
            false
        );


        setPdfPageUrl(
            null
        );


        //====================================================
        // PDF Page Endpoint
        //====================================================

        const url =

            "/resolutionsoftwareplatform/api/sharepoint/file/" +
            encodeURIComponent(
                documentSharepointId
            ) +
            "/page/" +
            currentPage;


        //====================================================
        // Retrieve PDF Page
        //====================================================

        functions.getBlobFromAjax(

            url,

            function(blob)
            {

                if (
                    cancelled
                )
                {

                    return;

                }


                if (
                    !blob
                )
                {

                    setPdfLoading(
                        false
                    );


                    setPdfError(
                        true
                    );


                    return;

                }


                //================================================
                // Create Browser URL
                //================================================

                objectUrl =

                    window.URL.createObjectURL(
                        blob
                    );


                setPdfPageUrl(
                    objectUrl
                );


                setPdfLoading(
                    false
                );

            }

        );


        //====================================================
        // Cleanup
        //====================================================

        return () =>
        {

            cancelled =
                true;


            if (
                objectUrl
            )
            {

                window.URL.revokeObjectURL(
                    objectUrl
                );

            }

        };

    }, [

        visible,

        documentSharepointId,

        currentPage

    ]);


    //========================================================
    // Previous Page
    //========================================================

    const handlePreviousPage = () =>
    {

        setCurrentPage(

            currentPage =>

                Math.max(
                    1,
                    currentPage - 1
                )

        );


        if (
            onPreviousPage
        )
        {

            onPreviousPage();

        }

    };


    //========================================================
    // Next Page
    //========================================================

    const handleNextPage = () =>
    {

        setCurrentPage(

            currentPage =>

                Math.min(
                    documentTotalPages,
                    currentPage + 1
                )

        );


        if (
            onNextPage
        )
        {

            onNextPage();

        }

    };


    //========================================================
    // View Page Content
    //========================================================

    const handleViewSnippets = () =>
    {

        console.log(

            "OPEN PAGE CONTENT",

            pageContentResponse

        );


        if (
            !pageContentResponse
        )
        {

            return;

        }


        setSnippetSelectionVisible(
            true
        );

    };


    //========================================================
    // Selectable Content
    //========================================================

    const hasSelectableContent =

        !pageContentLoading &&

        pageContentResponse?.hasSelectableContent === true &&

        Array.isArray(
            pageContentResponse?.sections
        ) &&

        pageContentResponse.sections.length > 0;


    //========================================================
    // Position
    //========================================================

    const drawerStyle =
    {

        ...styles.drawer,

        width:
            DOCUMENT_DRAWER_WIDTH,

        right:
            visible
                ?
                SNIPPET_DRAWER_WIDTH
                :
                -DOCUMENT_DRAWER_WIDTH

    };


    //========================================================
    // Debug
    //========================================================

    console.log(

        "PAGE CONTENT",

        {

            documentId,

            currentPage,

            pageContentLoading,

            pageContentResponse,

            hasSelectableContent,

            hasOnViewSnippets:
                !!onViewSnippets,

            snippetSelectionVisible

        }

    );


    //========================================================
    // Render
    //========================================================

    return (

        <div style={drawerStyle}>


            {/*============================================
                Header
            ============================================*/}

            <div style={styles.header}>

                <div style={styles.headerText}>

                    <div style={styles.eyebrow}>

                        SOURCE DOCUMENT

                    </div>

                    <div style={styles.title}>

                        {
                            documentTitle ||
                            "Untitled Document"
                        }

                    </div>

                </div>


                {/*========================================
                    Full Document
                ========================================*/}

                <button

                    type="button"

                    style={
                        styles.fullDocumentButton
                    }

                    onClick={
                        onViewFullDocument
                    }

                    title="View full document"

                >

                    <FontAwesomeIcon
                        icon={faExpand}
                    />

                    <span>
                        Full Document
                    </span>

                </button>

            </div>


            {/*============================================
                Navigation
            ============================================*/}

            <div style={styles.navigation}>


                {/*========================================
                    Previous
                ========================================*/}

                <button

                    type="button"

                    style={
                        {
                            ...styles.navigationButton,

                            ...(currentPage <= 1
                                ? styles.navigationButtonDisabled
                                : {})
                        }
                    }

                    onClick={
                        handlePreviousPage
                    }

                    disabled={
                        currentPage <= 1
                    }

                >

                    <FontAwesomeIcon
                        icon={faChevronLeft}
                    />

                    <span>
                        Previous
                    </span>

                </button>


                {/*========================================
                    Page Indicator
                ========================================*/}

                <div style={styles.pageIndicator}>

                    <span style={styles.pageLabel}>
                        Page
                    </span>

                    <span style={styles.pageNumber}>
                        {currentPage}
                    </span>

                    <span style={styles.pageDivider}>
                        of
                    </span>

                    <span style={styles.totalPages}>
                        {documentTotalPages}
                    </span>

                </div>


                {/*========================================
                    Next
                ========================================*/}

                <button

                    type="button"

                    style={
                        {
                            ...styles.navigationButton,

                            ...(currentPage >= documentTotalPages
                                ? styles.navigationButtonDisabled
                                : {})
                        }
                    }

                    onClick={
                        handleNextPage
                    }

                    disabled={
                        currentPage >= documentTotalPages
                    }

                >

                    <span>
                        Next
                    </span>

                    <FontAwesomeIcon
                        icon={faChevronRight}
                    />

                </button>

            </div>


            {/*============================================
                PDF Page Workspace
            ============================================*/}

            <div style={styles.content}>


                {/*========================================
                    Loading
                ========================================*/}

                {

                    pdfLoading &&

                    (

                        <div style={styles.placeholder}>

                            <div style={styles.progressWheel}>

                                <svg
                                    width="54"
                                    height="54"
                                    viewBox="0 0 54 54"
                                >

                                    <circle
                                        cx="27"
                                        cy="27"
                                        r="22"
                                        fill="none"
                                        stroke="rgba(38,55,70,0.10)"
                                        strokeWidth="4"
                                    />

                                    <circle
                                        cx="27"
                                        cy="27"
                                        r="22"
                                        fill="none"
                                        stroke={OMNISCAN_BLUE}
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                        strokeDasharray="90 50"
                                    >

                                        <animateTransform
                                            attributeName="transform"
                                            type="rotate"
                                            from="0 27 27"
                                            to="360 27 27"
                                            dur="0.85s"
                                            repeatCount="indefinite"
                                        />

                                    </circle>

                                </svg>

                            </div>

                            <div style={styles.placeholderTitle}>
                                Loading Page
                            </div>

                            <div style={styles.placeholderText}>
                                Retrieving original PDF page...
                            </div>

                        </div>

                    )

                }


                {/*========================================
                    PDF
                ========================================*/}

                {

                    !pdfLoading &&
                    !pdfError &&
                    pdfPageUrl &&

                    (

                        <div style={styles.page}>

                            <iframe

                                key={
                                    documentSharepointId +
                                    "-" +
                                    currentPage
                                }

                                src={
                                    pdfPageUrl
                                }

                                title={
                                    documentTitle +
                                    " - Page " +
                                    currentPage
                                }

                                style={
                                    styles.pdfFrame
                                }

                            />

                        </div>

                    )

                }


                {/*========================================
                    Error
                ========================================*/}

                {

                    !pdfLoading &&
                    pdfError &&

                    (

                        <div style={styles.placeholder}>

                            <div style={styles.placeholderTitle}>
                                Page Unavailable
                            </div>

                            <div style={styles.placeholderText}>
                                The original PDF page could not be retrieved.
                            </div>

                        </div>

                    )

                }


                {/*========================================
                    No Document
                ========================================*/}

                {

                    !pdfLoading &&
                    !pdfError &&
                    !pdfPageUrl &&
                    !documentSharepointId &&

                    (

                        <div style={styles.placeholder}>

                            <div style={styles.placeholderTitle}>
                                Document Unavailable
                            </div>

                            <div style={styles.placeholderText}>
                                No SharePoint document is available.
                            </div>

                        </div>

                    )

                }

            </div>


            {/*============================================
                Footer Toolbar
            ============================================*/}

            <div style={styles.footer}>


                {/*========================================
                    View Content
                ========================================*/}

                <div style={styles.footerLeft}>

                    {

                        hasSelectableContent &&

                        (

                            <button

                                type="button"

                                style={
                                    styles.secondaryButton
                                }

                                onClick={
                                    handleViewSnippets
                                }

                            >

                                View Content

                            </button>

                        )

                    }

                </div>


                {/*========================================
                    Add Page
                ========================================*/}

                <button

                    type="button"

                    style={
                        styles.primaryButton
                    }

                    onClick={
                        () =>
                        {

                            if (
                                onAddPage
                            )
                            {

                                onAddPage(
                                    {
                                        documentId,

                                        documentSharepointId,

                                        documentTitle,

                                        pageNumber:
                                            currentPage,

                                        documentSnippetId:
                                            pageContentResponse?.documentSnippetId ||
                                            null
                                    }
                                );

                            }

                        }
                    }

                >

                    Add Page to Basket

                </button>

            </div>


            {/*============================================
                Page Content Selection
            ============================================*/}

            <DynamicSnippetSelectionDrawer

                visible={
                    snippetSelectionVisible
                }

                documentTitle={
                    documentTitle
                }

                pageNumber={
                    currentPage
                }

                documentSnippetId={
                    pageContentResponse?.documentSnippetId
                }

                sections={
                    pageContentResponse?.sections || []
                }

                onClose={
                    () =>
                    {

                        setSnippetSelectionVisible(
                            false
                        );

                    }
                }

				onAddSelected={
				    (selectedSections) =>
				    {
				        console.log(

				            "SELECTED PAGE CONTENT",

				            selectedSections

				        );


				        //====================================================
				        // Add Selected Content To Document Builder Basket
				        //====================================================

				        if (

				            onViewSnippets

				        )

				        {

				            onViewSnippets(

				                {

				                    documentId,

				                    documentSharepointId,

				                    documentTitle,

				                    pageNumber:

				                        currentPage,

				                    documentSnippetId:

				                        pageContentResponse?.documentSnippetId,

				                    contentType:

				                        pageContentResponse?.contentType,

				                    sections:

				                        selectedSections

				                }

				            );

				        }


				        //====================================================
				        // Close Selection Drawer
				        //====================================================

				        setSnippetSelectionVisible(

				            false

				        );

				    }
				}

            />

        </div>

    );

}


//========================================================
// Styles
//========================================================

const styles =
{

    //========================================================
    // Drawer
    //========================================================

    drawer:
    {

        position:
            "fixed",

        top:
            0,

        bottom:
            0,

        background:
            "#f4f7f9",

        borderLeft:
            "1px solid rgba(38,55,70,0.10)",

        boxShadow:
            "-12px 0 35px rgba(20,35,50,0.12)",

        zIndex:
            999,

        display:
            "flex",

        flexDirection:
            "column",

        overflow:
            "hidden",

        transition:
            "right 820ms cubic-bezier(0.22, 1, 0.36, 1)"

    },


    //========================================================
    // Header
    //========================================================

    header:
    {

        height:
            84,

        minHeight:
            84,

        padding:
            "0 26px",

        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "space-between",

        background:
            "#ffffff",

        borderBottom:
            "1px solid rgba(38,55,70,0.08)"

    },

    headerText:
    {

        minWidth:
            0,

        paddingRight:
            20

    },

    eyebrow:
    {

        marginBottom:
            5,

        fontSize:
            10,

        fontWeight:
            700,

        letterSpacing:
            1.4,

        color:
            "rgba(38,55,70,0.45)"

    },

    title:
    {

        fontSize:
            17,

        fontWeight:
            600,

        color:
            "#263746",

        whiteSpace:
            "nowrap",

        overflow:
            "hidden",

        textOverflow:
            "ellipsis"

    },


    //========================================================
    // Full Document Button
    //========================================================

    fullDocumentButton:
    {

        height:
            38,

        padding:
            "0 15px",

        display:
            "flex",

        alignItems:
            "center",

        gap:
            9,

        border:
            "1px solid rgba(38,55,70,0.14)",

        borderRadius:
            6,

        background:
            "#f4f7f9",

        color:
            "#263746",

        fontSize:
            12,

        fontWeight:
            600,

        cursor:
            "pointer",

        whiteSpace:
            "nowrap"

    },


    //========================================================
    // Navigation
    //========================================================

    navigation:
    {

        height:
            58,

        minHeight:
            58,

        padding:
            "0 24px",

        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "space-between",

        background:
            "#ffffff",

        borderBottom:
            "1px solid rgba(38,55,70,0.08)"

    },

    navigationButton:
    {

        minWidth:
            100,

        height:
            34,

        padding:
            "0 12px",

        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "center",

        gap:
            8,

        border:
            "none",

        background:
            "transparent",

        color:
            "#263746",

        fontSize:
            12,

        fontWeight:
            600,

        cursor:
            "pointer"

    },

    navigationButtonDisabled:
    {

        opacity:
            0.3,

        cursor:
            "default"

    },


    //========================================================
    // Page Indicator
    //========================================================

    pageIndicator:
    {

        display:
            "flex",

        alignItems:
            "center",

        gap:
            7,

        fontSize:
            12

    },

    pageLabel:
    {

        color:
            "rgba(38,55,70,0.50)"

    },

    pageNumber:
    {

        minWidth:
            28,

        padding:
            "5px 8px",

        textAlign:
            "center",

        background:
            "#f4f7f9",

        border:
            "1px solid rgba(38,55,70,0.10)",

        borderRadius:
            4,

        color:
            "#263746",

        fontWeight:
            700

    },

    pageDivider:
    {

        color:
            "rgba(38,55,70,0.40)"

    },

    totalPages:
    {

        color:
            "#263746",

        fontWeight:
            600

    },


    //========================================================
    // Content
    //========================================================

    content:
    {

        position:
            "relative",

        flex:
            1,

        minHeight:
            0,

        padding:
            24,

        overflow:
            "hidden",

        display:
            "flex"

    },


    //========================================================
    // PDF Page
    //========================================================

    page:
    {

        flex:
            1,

        minHeight:
            0,

        overflow:
            "hidden",

        background:
            "#ffffff",

        border:
            "1px solid rgba(38,55,70,0.08)",

        borderRadius:
            6,

        boxShadow:
            "0 8px 24px rgba(20,35,50,0.06)"

    },


    //========================================================
    // PDF Frame
    //========================================================

    pdfFrame:
    {

        width:
            "100%",

        height:
            "100%",

        display:
            "block",

        border:
            "none",

        background:
            "#ffffff"

    },


    //========================================================
    // Placeholder
    //========================================================

    placeholder:
    {

        width:
            "100%",

        height:
            "100%",

        display:
            "flex",

        flexDirection:
            "column",

        alignItems:
            "center",

        justifyContent:
            "center",

        background:
            "#ffffff",

        border:
            "1px solid rgba(38,55,70,0.08)",

        borderRadius:
            6,

        boxShadow:
            "0 8px 24px rgba(20,35,50,0.06)"

    },

    progressWheel:
    {

        width:
            54,

        height:
            54,

        marginBottom:
            18,

        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "center"

    },

    placeholderTitle:
    {

        marginBottom:
            7,

        fontSize:
            15,

        fontWeight:
            600,

        color:
            "#263746"

    },

    placeholderText:
    {

        fontSize:
            12,

        fontWeight:
            400,

        color:
            "rgba(38,55,70,0.48)"

    },


    //========================================================
    // Footer
    //========================================================

    footer:
    {

        height:
            74,

        minHeight:
            74,

        padding:
            "0 22px",

        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "space-between",

        background:
            "#ffffff",

        borderTop:
            "1px solid rgba(38,55,70,0.08)"

    },

    footerLeft:
    {

        minWidth:
            1,

        display:
            "flex",

        alignItems:
            "center"

    },


    //========================================================
    // Secondary Button
    //========================================================

    secondaryButton:
    {

        height:
            40,

        padding:
            "0 16px",

        border:
            "1px solid rgba(38,55,70,0.14)",

        borderRadius:
            6,

        background:
            "#f4f7f9",

        color:
            "#263746",

        fontSize:
            12,

        fontWeight:
            600,

        cursor:
            "pointer"

    },


    //========================================================
    // Primary Button
    //========================================================

    primaryButton:
    {

        height:
            40,

        padding:
            "0 18px",

        border:
            "none",

        borderRadius:
            6,

        background:
            OMNISCAN_BLUE,

        color:
            "#ffffff",

        fontSize:
            12,

        fontWeight:
            600,

        cursor:
            "pointer"

    }

};